import "../App.css";
import config from "../config";
import ReCAPTCHA from "react-google-recaptcha";
import React, { useState, useEffect, useRef } from "react";

import { ReactComponent as Visa } from "../images/visa.svg";
import { ReactComponent as Mastercard } from "../images/mastercard.svg";
import { ReactComponent as AmericanExpress } from "../images/american-express.svg";

export default function PinPayment(props) {
  const form = props.form;
  const product = props.product;
  let fieldsRef = useRef(null);
  let captchaRef = useRef(null);

  const [cardErrors, setCardErrors] = useState({});
  const [captchaError, setCaptchaError] = useState(false);

  const submission = (e) => {
    e.preventDefault();
    tokenizeHostedFields();
  };

  const mapCaptcha = (e) => {
    setCaptchaError(false);

    if (captchaRef.current.getValue() !== "") {
      props.setCaptcha(captchaRef.current.getValue())
      return submission(e);
    }
    setCaptchaError(true);
  };

  const tokenizeHostedFields = () => {
    var handled = false;

    fieldsRef.current.tokenize(
      {
        publishable_api_key: config.pin.publishable_api_key,
        address_line1: form.address_1,
        address_line2: form.address_2,
        address_city: form.suburb,
        address_postcode: form.postcode,
        address_state: form.state,
        address_country: "Australia",
      },
      function (err, response) {
        //code is here due to an error causing the request to be made multiple times
        //if first entering invalid details followed by valid details
        if (handled) return false;
        handled = true;

        if (err) {
          const errors = err.messages.reduce((total, individual) => {
            return { ...total, [individual.code]: individual.message };
          }, {});
          setCardErrors(errors);
          return;
        }
        props.onSubmit(response.token);
      }
    );
  };

  useEffect(() => {
    fieldsRef.current = window.HostedFields.create({
      sandbox: config.pin.sandbox,
      autocomplete: true,
      styles: {
        input: {
          "font-size": "13px",
          "font-family": "Arial, sans-serif",
          color: "#32325d",
        },
        ".hosted-fields-invalid:not(:focus)": {
          color: "#fa755a",
        },
      },
      fields: {
        name: {
          selector: "#name",
          placeholder: "Name on Card",
        },
        number: {
          selector: "#number",
          placeholder: "4111 1111 1111 1111",
        },
        cvc: {
          selector: "#cvc",
          placeholder: "123",
        },
        expiry: {
          selector: "#expiry",
          placeholder: "12/34",
        },
      },
    });
  }, []);

  return (
    <>
      <form id="payment_form">
        <div className="flex justify-between">
          <h4 className="text-2xl font-semibold">Payment</h4>
          {!form.additional_form && <h4 className="text-xl font-semibold">${product.totalPrice}</h4>}
          {form.additional_form && <h4 className="text-xl font-semibold">
            ${(+product.totalPrice + +form.additional_form.totalPrice).toFixed(2)}
            </h4>}
        </div>
        <div className="flex justify-between sm:items-center mb-6">
          <p className="leading-relaxed text-gray-600 mr-2">
            Please enter your payment details.
          </p>
          <div className="flex justify-between items-center">
            <Visa className="h-11 w-11 mr-1 mb-1 " />
            <Mastercard className=" h-10 w-10" />
            <AmericanExpress className=" h-10 w-10 mt-2" />
          </div>
        </div>
        <label
          htmlFor="name"
          className="block uppercase text-gray-700 text-xs font-bold"
        >
          Full name
        </label>

        <div
          className={
            cardErrors.name_invalid
              ? " border-red-500 border-x border-y text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              : "border-0  text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
          }
        >
          <div id="name" className="h-10 pin-input">
            {/*  Hosted Fields will populate this with the 'name' field */}
          </div>
        </div>
        <p
          className={
            cardErrors.name_invalid ? "text-red-600 text-xs mt-2" : "hidden"
          }
        >
          {cardErrors.name_invalid}
        </p>

        <div id="errors_for_name" className="error_message"></div>

        <label
          htmlFor="number"
          className="block uppercase text-gray-700 text-xs font-bold mt-2"
        >
          Card number
        </label>

        <div
          className={
            cardErrors.number_invalid
              ? " border-red-500 border-x border-y text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              : "border-0  text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
          }
        >
          <div id="number" className="h-10 pin-input">
            {/* <!-- Hosted Fields will populate this with the 'number' field --> */}
          </div>
        </div>
        <p
          className={
            cardErrors.number_invalid ? "text-red-600 text-xs mt-2" : "hidden"
          }
        >
          {cardErrors.number_invalid}
        </p>

        <div id="errors_for_number" className="error_message"></div>

        <div className="mt-2 flex">
          {/* cvc div */}
          <div className="w-full">
            <label
              htmlFor="cvc"
              className="block uppercase text-gray-700 text-xs font-bold "
            >
              CVC
            </label>

            <div
              className={
                cardErrors.cvc_invalid
                  ? " border-red-500 border-x border-y mr-2 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0  text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full mr-2 "
              }
            >
              <div id="cvc" className="h-10 pin-input">
                {/* <!-- Hosted Fields will populate this with the 'cvc' field --> */}
              </div>
            </div>
            <p
              className={
                cardErrors.cvc_invalid ? "text-red-600 text-xs mt-2" : "hidden"
              }
            >
              {cardErrors.cvc_invalid}
            </p>
          </div>

          <div id="errors_for_cvc" className="error_message"></div>

          {/* expiry div */}
          <div className="w-full">
            <label
              htmlFor="expiry"
              className="block uppercase text-gray-700 text-xs font-bold "
            >
              Expiry
            </label>

            <div
              className={
                cardErrors.expiry_invalid
                  ? " border-red-500 border-x border-y text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0  text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
            >
              <div id="expiry" className="h-10 pin-input">
                {/* <!-- Hosted Fields will populate this with the 'expiry' field --> */}
              </div>
            </div>
            <p
              className={
                cardErrors.expiry_invalid
                  ? "text-red-600 text-xs mt-2"
                  : "hidden"
              }
            >
              {cardErrors.expiry_invalid}
            </p>
          </div>

          <div id="errors_for_expiry" className="error_message"></div>
        </div>
      </form>

      <div className="mt-6">
        <ReCAPTCHA
          sitekey={config.recaptcha.site_key}
          onChange={mapCaptcha}
          ref={captchaRef}
        />
      </div>

      <div className="text-center flex justify-between mt-6">
        <button
          className="text-white bg-black focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={props.prevStep}
        >
          Back
        </button>
        <button
          className="text-white bg-[#005b95] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={mapCaptcha}
        >
          Pay
        </button>
      </div>
      <p className={props.error ? "text-red-600 text-s mt-2" : "hidden"}>
        {props.error}
      </p>
      <p className={captchaError ? "text-red-600 text-s mt-2" : "hidden"}>
        reCAPTCHA must be completed.
      </p>
    </>
  );
}
